import api from '~/state/api/index.js';
import ui from '~/state/ducks/ui/actions.js';
import { toVertexLogoURL } from '~/utils/transform.js';


export const transform = ({
    logo_id,
    logo_url,
    ...data
}) => ({
    ...data,
    logo_url: toVertexLogoURL({ logo_id, logo_url }),
});

export const fetchAuthor = id => async (dispatch) => {
    try {
        const { data } = await dispatch(api.get(`/users/${id}`));

        return transform(data);

    } catch (error) {
        dispatch(ui.flash.error({ header: 'Author not found' }, error));
    }
};
